<script>
import Loader from "../../components/Loader.vue";
import { getCategoryTypes } from '../../utilities/categoryTypes'

export default {
  props: {
    // The flags to filter by. Please note that this component will only include
    // CategoryTypes that match *all* these flags
    flags: {
      type: Array,
      required: false,
    },

    // Callback taking category type objects as an argument that is called for
    // filtering purposes. Return falsy to omit the type
    filter: {},

    withValues: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  components: { Loader },

  data() {
    return {
      categories: null,
    };
  },

  mounted() {
    this._loadGenericCategoryTypes();
  },

  methods: {
    async _loadGenericCategoryTypes() {
      this.categories = (await getCategoryTypes(this.withValues))
        .filter(this.flags
          ? (ct) => {
            // If there are any filter flags not present in the category type's
            // flags, we return false.
            return this.flags.filter(f => !ct.flags.includes(f)).length === 0;
          }
          : () => true
        )
        .filter(this.filter || (() => true))
        ;
    },
  },
}
</script>

<template>
  <loader :loading="categories === null">
    <slot name="categories" v-bind="{ categories }"></slot>
  </loader>
</template>
